import { createServerFn } from '@tanstack/react-start'
import { requireSupabaseAuth } from '@/integrations/supabase/auth-middleware'
import type { PayoutAlertInfo } from '@/lib/payout-alert.server'

/** Dashboard read: the next payout and whether it is close enough to flag. */
export const getPayoutAlert = createServerFn({ method: 'POST' })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }): Promise<PayoutAlertInfo> => {
    const { data: isAdmin } = await context.supabase.rpc('has_role', {
      _user_id: context.userId,
      _role: 'admin',
    })
    if (!isAdmin) throw new Response('Forbidden', { status: 403 })

    const { getUpcomingPayoutInfo } = await import('@/lib/payout-alert.server')
    return getUpcomingPayoutInfo()
  })
